import type { CustomFieldDto, Metadata } from './generated/kubb/kubb-types';
import type { KeyValueFieldObject } from './types';

type KeyValueField = {
  key: string;
  value: CustomFieldDto['value'];
};

export type WithFormattedMetadata<T extends { metadata: Metadata[] }> = Omit<T, 'metadata'> & {
  metadata: KeyValueFieldObject;
};

export type WithDataFormattedMetadata<T extends { data: Array<{ metadata: Metadata[] }> }> = Omit<
  T,
  'data'
> & {
  data: Array<WithFormattedMetadata<T['data'][number]>>;
};

export const keyValueFieldsToObject = <T extends KeyValueFieldObject>(fields: KeyValueField[]) => {
  return Object.fromEntries(fields.map(({ key, value }) => [key, value])) as T;
};

export const toKeyValueFields = (obj: Record<string, CustomFieldDto['value']>) => {
  return Object.entries(obj)
    .filter(([_, value]) => value !== undefined)
    .map(([key, value]) => ({ key, value }));
};
